// Centralized SEO translations for all pages
// Each page has unique titles and descriptions for each language
// Optimized: titles 50-60 chars, descriptions 140-160 chars

export const seoTranslations: Record<string, Record<string, { title: string; description: string }>> = {
  home: {
    sk: {
      // 56 chars
      title: "Legalizácia dokumentov a úradné preklady | Prelozim.sk",
      // 156 chars
      description: "Apostille a superlegalizácia dokumentov, profesionálne úradné preklady od 30€ za normostranu. Online kalkulácia ceny, expresné dodanie do 24 hodín v Bratislave."
    },
    en: {
      // 60 chars
      title: "Document Legalization & Certified Translations Slovakia €30",
      // 154 chars
      description: "Apostille and superlegalization services in Slovakia. Certified translations from €30 per page by court translators. Express 24h delivery across EU."
    },
    de: {
      // 58 chars
      title: "Dokumentenlegalisierung & beglaubigte Übersetzungen Slowakei",
      // 152 chars
      description: "Apostille und Superlegalisation in der Slowakei. Amtliche Übersetzungen ab 30€ pro Seite. Slowakisch-Deutsch Übersetzer, Express 24h Lieferung nach Deutschland."
    },
    uk: {
      // 56 chars
      title: "Легалізація документів та офіційні переклади Словаччина",
      // 158 chars
      description: "Апостиль та суперлегалізація документів у Словаччині. Офіційні переклади від 30€ за сторінку українською та словацькою. Експрес доставка 24 години в Україну."
    },
    ru: {
      // 56 chars
      title: "Легализация документов и официальные переводы Словакия",
      // 155 chars
      description: "Апостиль и суперлегализация документов в Словакии. Официальные переводы от 30€ за страницу. Словацкий, русский переводчики. Экспресс доставка 24 часа в РФ."
    },
    es: {
      // 58 chars
      title: "Legalización de documentos y traducciones oficiales Eslovaquia",
      // 156 chars
      description: "Apostilla y superlegalización en Eslovaquia. Traducciones oficiales desde 30€ por página. Eslovaco, español, inglés. Entrega exprés 24h. Agencia certificada."
    }
  },
  calculator: {
    sk: {
      // 52 chars
      title: "Kalkulačka ceny úradného prekladu | Prelozim.sk",
      // 148 chars
      description: "Vypočítajte si cenu úradného prekladu online za 30 sekúnd. Nahrajte dokument a okamžite zistíte presnú cenu. Bez skrytých poplatkov, expresné dodanie."
    },
    en: {
      // 54 chars
      title: "Translation Price Calculator | Slovak Agency Quote",
      // 152 chars
      description: "Calculate official translation costs from Slovak agency instantly. Upload document, get exact price in 30 seconds. No hidden fees. Express EU delivery available."
    },
    de: {
      // 55 chars
      title: "Übersetzungs-Preisrechner | Slowakei Sofortangebot",
      // 150 chars
      description: "Berechnen Sie Übersetzungskosten aus der Slowakei sofort. Dokument hochladen, Preis in 30 Sekunden erhalten. Keine versteckten Gebühren. Express Lieferung."
    },
    uk: {
      // 52 chars
      title: "Калькулятор перекладу | Словаччина миттєва ціна",
      // 154 chars
      description: "Розрахуйте вартість офіційного перекладу зі Словаччини за 30 секунд. Завантажте документ - отримайте точну ціну. Без прихованих платежів. Експрес в Україну."
    },
    ru: {
      // 54 chars
      title: "Калькулятор перевода | Словакия мгновенная цена",
      // 155 chars
      description: "Рассчитайте стоимость официального перевода из Словакии за 30 секунд. Загрузите документ - получите точную цену. Без скрытых платежей. Экспресс доставка в РФ."
    },
    es: {
      // 56 chars
      title: "Calculadora de traducción | Eslovaquia presupuesto ya",
      // 153 chars
      description: "Calcule costes de traducción oficial desde Eslovaquia al instante. Suba documento, obtenga precio en 30 segundos. Sin gastos ocultos. Entrega exprés a España."
    }
  },
  pricing: {
    sk: {
      // 54 chars
      title: "Cenník úradných prekladov a legalizácie | Prelozim",
      // 148 chars
      description: "Transparentný cenník úradných prekladov od 30€ za normostranu. Apostille, superlegalizácia, expresné príplatky. Bez skrytých poplatkov, všetko online."
    },
    en: {
      // 54 chars
      title: "Translation Prices Slovakia | Certified Rates €30",
      // 155 chars
      description: "Transparent pricing from Slovak certified translation agency. Certified translations from €30 per page. Apostille, legalization fees included. No hidden costs."
    },
    de: {
      // 54 chars
      title: "Übersetzungspreise Slowakei | Amtliche Tarife ab 30€",
      // 152 chars
      description: "Transparente Preise aus slowakischem Übersetzungsbüro. Amtliche Übersetzungen ab 30€ pro Seite. Apostille, Legalisation inklusive. Lieferung nach Deutschland."
    },
    uk: {
      // 54 chars
      title: "Ціни на переклад Словаччина | Офіційні тарифи від 30€",
      // 148 chars
      description: "Прозорі ціни зі словацького бюро перекладів. Офіційні переклади від 30€ за сторінку. Апостиль, легалізація включені. Доставка в Україну експресом."
    },
    ru: {
      // 54 chars
      title: "Цены на перевод Словакия | Официальные тарифы от 30€",
      // 150 chars
      description: "Прозрачные цены из словацкого бюро переводов. Официальные переводы от 30€ за страницу. Апостиль, легализация включены. Экспресс доставка в РФ и СНГ."
    },
    es: {
      // 56 chars
      title: "Precios de traducción Eslovaquia | Tarifas desde 30€",
      // 151 chars
      description: "Precios transparentes de agencia eslovaca certificada. Traducciones oficiales desde 30€ por página. Apostilla, legalización incluidas. Envío a España."
    }
  },
  about: {
    sk: {
      // 54 chars
      title: "O nás – Profesionálne preklady od 2013 | Prelozim.sk",
      // 154 chars
      description: "11 rokov skúseností s úradnými prekladmi a legalizáciou. Súčasť Legalizačného centra Bratislava a advokátskej kancelárie AKMV. 180+ pozitívnych hodnotení."
    },
    en: {
      // 52 chars
      title: "About Us | Slovak Translation Agency Since 2013",
      // 158 chars
      description: "11 years of official translation experience from Slovakia. Part of Bratislava Legalization Center and AKMV law firm. 180+ Google reviews. Trusted Slovak translators."
    },
    de: {
      // 54 chars
      title: "Über uns | Slowakisches Übersetzungsbüro seit 2013",
      // 156 chars
      description: "11 Jahre Erfahrung mit amtlichen Übersetzungen aus der Slowakei. Teil des Legalisierungszentrums Bratislava und AKMV Kanzlei. 180+ Google Bewertungen. Vertrauenswürdig."
    },
    uk: {
      // 50 chars
      title: "Про нас | Бюро перекладів Словаччина з 2013 року",
      // 154 chars
      description: "11 років досвіду офіційних перекладів зі Словаччини. Частина Легалізаційного центру Братислава та АKMV. 180+ відгуків Google. Надійні словацькі перекладачі."
    },
    ru: {
      // 52 chars
      title: "О нас | Бюро переводов Словакия с 2013 года",
      // 156 chars
      description: "11 лет опыта официальных переводов из Словакии. Часть Легализационного центра Братислава и адвокатского бюро AKMV. 180+ отзывов Google. Надежные переводчики."
    },
    es: {
      // 58 chars
      title: "Sobre nosotros | Agencia traducción eslovaca desde 2013",
      // 155 chars
      description: "11 años de experiencia en traducciones oficiales desde Eslovaquia. Parte del Centro de Legalización Bratislava y bufete AKMV. 180+ reseñas Google positivas."
    }
  },
  faq: {
    sk: {
      // 56 chars
      title: "Časté otázky o úradných prekladoch | FAQ Prelozim.sk",
      // 152 chars
      description: "Odpovede na najčastejšie otázky o úradných prekladoch, apostille a superlegalizácii. Čo je úradný preklad, ako dlho trvá, koľko stojí, ako objednať online."
    },
    en: {
      // 56 chars
      title: "FAQ Certified Translations Slovakia | Questions & Answers",
      // 154 chars
      description: "Answers about certified translations from Slovakia. What is certified translation, processing time, pricing, delivery. Apostille and legalization explained."
    },
    de: {
      // 56 chars
      title: "FAQ Amtliche Übersetzungen Slowakei | Fragen & Antworten",
      // 152 chars
      description: "Antworten zu amtlichen Übersetzungen aus der Slowakei. Was ist beglaubigte Übersetzung, Bearbeitungszeit, Preise, Lieferung. Apostille und Legalisation erklärt."
    },
    uk: {
      // 52 chars
      title: "FAQ Офіційні переклади Словаччина | Питання та відповіді",
      // 150 chars
      description: "Відповіді про офіційні переклади зі Словаччини. Що таке сертифікований переклад, терміни виконання, ціни, доставка. Апостиль та легалізація пояснено."
    },
    ru: {
      // 52 chars
      title: "FAQ Официальные переводы Словакия | Вопросы и ответы",
      // 152 chars
      description: "Ответы об официальных переводах из Словакии. Что такое сертифицированный перевод, сроки выполнения, цены, доставка. Апостиль и легализация подробно."
    },
    es: {
      // 58 chars
      title: "FAQ Traducciones oficiales Eslovaquia | Preguntas frecuentes",
      // 150 chars
      description: "Respuestas sobre traducciones oficiales de Eslovaquia. Qué es traducción jurada, plazos de entrega, precios, envío. Apostilla y legalización explicadas."
    }
  },
  contact: {
    sk: {
      // 56 chars
      title: "Kontakt | Legalizačné centrum Bratislava – Prelozim.sk",
      // 146 chars
      description: "Kontaktujte nás: office@legalizacnecentrum.sk, +421 907 999 909. Pluhová 17, Bratislava. Otvorené Po-Pia 9:00-17:00. Online formulár pre dopyt."
    },
    en: {
      // 54 chars
      title: "Contact | Slovak Translation Agency Bratislava Office",
      // 152 chars
      description: "Contact Slovak translation agency: office@legalizacnecentrum.sk, +421 907 999 909. Address: Pluhová 17, Bratislava, Slovakia. Open Mon-Fri 9:00-17:00 CET."
    },
    de: {
      // 54 chars
      title: "Kontakt | Slowakisches Übersetzungsbüro Bratislava",
      // 154 chars
      description: "Kontakt slowakisches Übersetzungsbüro: office@legalizacnecentrum.sk, +421 907 999 909. Adresse: Pluhová 17, Bratislava, Slowakei. Geöffnet Mo-Fr 9:00-17:00."
    },
    uk: {
      // 56 chars
      title: "Контакт | Словацьке бюро перекладів офіс Братислава",
      // 154 chars
      description: "Контакт словацького бюро перекладів: office@legalizacnecentrum.sk, +421 907 999 909. Адреса: Pluhová 17, Братислава, Словаччина. Відкрито Пн-Пт 9:00-17:00."
    },
    ru: {
      // 52 chars
      title: "Контакт | Бюро переводов Словакия офис Братислава",
      // 152 chars
      description: "Контакт словацкого бюро переводов: office@legalizacnecentrum.sk, +421 907 999 909. Адрес: Pluhová 17, Братислава, Словакия. Открыто Пн-Пт 9:00-17:00 CET."
    },
    es: {
      // 54 chars
      title: "Contacto | Agencia traducción eslovaca en Bratislava",
      // 150 chars
      description: "Contacto agencia eslovaca: office@legalizacnecentrum.sk, +421 907 999 909. Dirección: Pluhová 17, Bratislava, Eslovaquia. Abierto Lun-Vie 9:00-17:00."
    }
  },
  translations: {
    sk: {
      // 52 chars
      title: "Úradné preklady od 30€ za stranu | Prelozim.sk",
      // 156 chars
      description: "Profesionálne úradné preklady overené súdnym prekladateľom. Rodné listy, diplomy, zmluvy, výpisy z registra. Expresné dodanie do 24 hodín. Online kalkulácia."
    },
    en: {
      // 56 chars
      title: "Certified Translations Slovakia | Court Translators €30",
      // 154 chars
      description: "Certified translations by Slovak court translators. Birth certificates, diplomas, contracts, extracts. Express 24h delivery across EU. Apostille ready."
    },
    de: {
      // 56 chars
      title: "Amtliche Übersetzungen Slowakei | Gerichtsübersetzer 30€",
      // 156 chars
      description: "Amtliche Übersetzungen von slowakischen Gerichtsübersetzern. Geburtsurkunden, Diplome, Verträge, Registerauszüge. Express 24h nach Deutschland. Apostille bereit."
    },
    uk: {
      // 54 chars
      title: "Офіційні переклади Словаччина | Судові перекладачі 30€",
      // 154 chars
      description: "Офіційні переклади від сертифікованих словацьких судових перекладачів. Свідоцтва, дипломи, договори, виписки. Експрес 24 години в Україну. Апостиль готовий."
    },
    ru: {
      // 54 chars
      title: "Официальные переводы Словакия | Судебные переводчики 30€",
      // 152 chars
      description: "Официальные переводы от сертифицированных словацких судебных переводчиков. Свидетельства, дипломы, договоры, выписки. Экспресс 24ч. Апостиль готов."
    },
    es: {
      // 58 chars
      title: "Traducciones oficiales Eslovaquia | Traductores jurados 30€",
      // 154 chars
      description: "Traducciones oficiales por traductores jurados eslovacos certificados. Certificados, diplomas, contratos, extractos. Entrega exprés 24h a España. Apostilla lista."
    }
  },
  legalization: {
    sk: {
      // 54 chars
      title: "Apostille a legalizácia dokumentov | Prelozim.sk",
      // 156 chars
      description: "Apostille od 120€, superlegalizácia od 500€ pre slovenské dokumenty. Legalizácia pre zahraničie vybavená za vás. Všetky úrady vrátane MZV. Bratislava centrum."
    },
    en: {
      // 56 chars
      title: "Apostille Slovakia | Document Legalization Service €120",
      // 154 chars
      description: "Apostille from €120, superlegalization from €500 for Slovak documents. Full legalization service for abroad. We handle all Slovak authorities including MFA."
    },
    de: {
      // 58 chars
      title: "Apostille Slowakei | Dokumentenlegalisierung Service ab 120€",
      // 152 chars
      description: "Apostille ab 120€, Superlegalisation ab 500€ für slowakische Dokumente. Kompletter Legalisierungsservice. Wir erledigen alle Behörden inklusive Außenministerium."
    },
    uk: {
      // 52 chars
      title: "Апостиль Словаччина | Легалізація документів від 120€",
      // 154 chars
      description: "Апостиль від 120€, суперлегалізація від 500€ для словацьких документів. Повна легалізація для закордону. Ми залагодимо все з органами включаючи МЗС Словаччини."
    },
    ru: {
      // 54 chars
      title: "Апостиль Словакия | Легализация документов от 120€",
      // 152 chars
      description: "Апостиль от 120€, суперлегализация от 500€ для словацких документов. Полная легализация для заграницы. Мы уладим всё с органами включая МИД Словакии."
    },
    es: {
      // 56 chars
      title: "Apostilla Eslovaquia | Legalización documentos desde 120€",
      // 154 chars
      description: "Apostilla desde 120€, superlegalización desde 500€ para documentos eslovacos. Servicio completo de legalización. Gestionamos todas las autoridades incluyendo MAE."
    }
  },
  terms: {
    sk: {
      // 50 chars
      title: "Obchodné podmienky prekladov | Prelozim.sk VOP",
      // 146 chars
      description: "Všeobecné obchodné podmienky pre prekladateľské služby Prelozim.sk. Objednávky, platby, reklamácie, zodpovednosť, ochrana osobných údajov podrobne."
    },
    en: {
      // 52 chars
      title: "Terms and Conditions | Prelozim.sk Translation ToS",
      // 148 chars
      description: "General terms and conditions for translation services at Prelozim.sk. Orders, payments, complaints, liability, personal data protection explained."
    },
    de: {
      // 54 chars
      title: "Allgemeine Geschäftsbedingungen | Prelozim.sk AGB",
      // 152 chars
      description: "Allgemeine Geschäftsbedingungen für Übersetzungsdienstleistungen bei Prelozim.sk. Bestellungen, Zahlungen, Reklamationen, Haftung, Datenschutz erklärt."
    },
    uk: {
      // 50 chars
      title: "Умови та положення перекладів | Prelozim.sk",
      // 148 chars
      description: "Загальні умови та положення для перекладацьких послуг Prelozim.sk. Замовлення, оплата, скарги, відповідальність, захист персональних даних детально."
    },
    ru: {
      // 52 chars
      title: "Условия и положения переводов | Prelozim.sk",
      // 150 chars
      description: "Общие условия и положения для переводческих услуг Prelozim.sk. Заказы, оплата, жалобы, ответственность, защита персональных данных подробно объяснены."
    },
    es: {
      // 54 chars
      title: "Términos y condiciones traducción | Prelozim.sk",
      // 150 chars
      description: "Términos y condiciones generales para servicios de traducción en Prelozim.sk. Pedidos, pagos, reclamaciones, responsabilidad, protección de datos."
    }
  },
  privacy: {
    sk: {
      // 52 chars
      title: "Ochrana osobných údajov a cookies | Prelozim.sk",
      // 154 chars
      description: "Zásady ochrany osobných údajov a používania cookies na Prelozim.sk. GDPR, bezpečnosť dokumentov, šifrovanie prenosu, automatické mazanie po 30 dňoch."
    },
    en: {
      // 50 chars
      title: "Privacy Policy and Cookies | Prelozim.sk GDPR",
      // 152 chars
      description: "Privacy policy and cookie usage at Prelozim.sk. GDPR compliance, document security, encrypted transfer, automatic deletion after 30 days explained."
    },
    de: {
      // 54 chars
      title: "Datenschutzerklärung und Cookies | Prelozim.sk DSGVO",
      // 154 chars
      description: "Datenschutzerklärung und Cookie-Nutzung bei Prelozim.sk. DSGVO-konform, Dokumentensicherheit, verschlüsselte Übertragung, automatische Löschung nach 30 Tagen."
    },
    uk: {
      // 54 chars
      title: "Політика конфіденційності та cookies | Prelozim.sk",
      // 152 chars
      description: "Політика конфіденційності та використання cookies на Prelozim.sk. GDPR, безпека документів, шифрований перенос, автоматичне видалення через 30 днів."
    },
    ru: {
      // 56 chars
      title: "Политика конфиденциальности и cookies | Prelozim.sk",
      // 154 chars
      description: "Политика конфиденциальности и использования cookies на Prelozim.sk. GDPR, безопасность документов, зашифрованная передача, автоматическое удаление 30 дней."
    },
    es: {
      // 54 chars
      title: "Política de privacidad y cookies | Prelozim.sk RGPD",
      // 152 chars
      description: "Política de privacidad y uso de cookies en Prelozim.sk. Cumplimiento RGPD, seguridad de documentos, transferencia cifrada, eliminación automática 30 días."
    }
  },
  apostila: {
    sk: {
      title: "Apostila dokumentov od 120€ | Vybavíme od 1 dňa | Prelozim.sk",
      description: "Profesionálne vybavenie apostily pre rodné listy, diplomy, výpisy z registra trestov a ďalšie dokumenty. Kompletný servis vrátane prekladu. Expresné vybavenie."
    },
    en: {
      title: "Apostille Slovakia from €120 | Document Legalization Service",
      description: "Professional apostille services for Slovak documents. Birth certificates, diplomas, criminal records. Complete service including translation. Express processing."
    },
    de: {
      title: "Apostille Slowakei ab 120€ | Dokumentenlegalisierung Service",
      description: "Professionelle Apostille-Dienste für slowakische Dokumente. Geburtsurkunden, Diplome, Strafregisterauszüge. Komplettservice inklusive Übersetzung. Express."
    },
    uk: {
      title: "Апостиль Словаччина від 120€ | Легалізація документів",
      description: "Професійні послуги апостилю для словацьких документів. Свідоцтва про народження, дипломи, довідки. Повний сервіс включаючи переклад. Експрес."
    },
    ru: {
      title: "Апостиль Словакия от 120€ | Легализация документов",
      description: "Профессиональные услуги апостиля для словацких документов. Свидетельства о рождении, дипломы, справки о несудимости. Полный сервис включая перевод."
    },
    es: {
      title: "Apostilla Eslovaquia desde 120€ | Legalización de documentos",
      description: "Servicios profesionales de apostilla para documentos eslovacos. Certificados de nacimiento, diplomas, antecedentes penales. Servicio completo con traducción."
    }
  },
  superlegalizacia: {
    sk: {
      title: "Superlegalizácia dokumentov | Pre krajiny mimo Haagu | Prelozim.sk",
      description: "Superlegalizácia slovenských dokumentov pre krajiny mimo Haagskej dohody. SAE, Čína, arabské krajiny. Kompletné vybavenie vrátane MZV a veľvyslanectva."
    },
    en: {
      title: "Superlegalization Slovakia | Documents for Non-Hague Countries",
      description: "Superlegalization of Slovak documents for countries outside Hague Convention. UAE, China, Arab countries. Complete service including MFA and embassy."
    },
    de: {
      title: "Superlegalisation Slowakei | Dokumente für Nicht-Haager Länder",
      description: "Superlegalisation slowakischer Dokumente für Länder außerhalb des Haager Abkommens. VAE, China, arabische Länder. Komplettservice inkl. Außenministerium."
    },
    uk: {
      title: "Суперлегалізація Словаччина | Документи для країн поза Гаагою",
      description: "Суперлегалізація словацьких документів для країн поза Гаазькою конвенцією. ОАЕ, Китай, арабські країни. Повний сервіс включаючи МЗС та посольство."
    },
    ru: {
      title: "Суперлегализация Словакия | Документы для стран вне Гааги",
      description: "Суперлегализация словацких документов для стран вне Гаагской конвенции. ОАЭ, Китай, арабские страны. Полный сервис включая МИД и посольство."
    },
    es: {
      title: "Superlegalización Eslovaquia | Documentos para países no-Haya",
      description: "Superlegalización de documentos eslovacos para países fuera del Convenio de La Haya. EAU, China, países árabes. Servicio completo incluyendo MAE y embajada."
    }
  },
  zahranicne_dokumenty: {
    sk: {
      title: "Apostila zahraničných dokumentov | Vybavíme v krajine vydania",
      description: "Zabezpečíme apostilu a superlegalizáciu zahraničných dokumentov priamo v krajine ich vydania. Rodné listy, diplomy, výpisy. Kompletný servis."
    },
    en: {
      title: "Foreign Documents Apostille | Processing in Country of Origin",
      description: "We arrange apostille and superlegalization of foreign documents directly in the country of issuance. Birth certificates, diplomas, extracts. Complete service."
    },
    de: {
      title: "Apostille ausländischer Dokumente | Bearbeitung im Ursprungsland",
      description: "Wir arrangieren Apostille und Superlegalisation ausländischer Dokumente direkt im Ausstellungsland. Geburtsurkunden, Diplome, Auszüge. Komplettservice."
    },
    uk: {
      title: "Апостиль іноземних документів | Оформлення в країні видачі",
      description: "Організуємо апостиль та суперлегалізацію іноземних документів безпосередньо в країні їх видачі. Свідоцтва, дипломи, виписки. Повний сервіс."
    },
    ru: {
      title: "Апостиль иностранных документов | Оформление в стране выдачи",
      description: "Организуем апостиль и суперлегализацию иностранных документов непосредственно в стране их выдачи. Свидетельства, дипломы, выписки. Полный сервис."
    },
    es: {
      title: "Apostilla de documentos extranjeros | Tramitación en país de origen",
      description: "Gestionamos apostilla y superlegalización de documentos extranjeros directamente en el país de emisión. Certificados, diplomas, extractos. Servicio completo."
    }
  },
  dopyt: {
    sk: {
      title: "Dopyt na apostilu a preklad | Nezáväzná cenová ponuka",
      description: "Vyplňte formulár a pošlite nám nezáväzný dopyt na apostilu, superlegalizáciu alebo úradný preklad dokumentov. Odpovieme do pár hodín."
    },
    en: {
      title: "Apostille and Translation Inquiry | Free Quote Request",
      description: "Fill out the form and send us a non-binding inquiry for apostille, superlegalization or official translation. We will respond within a few hours."
    },
    de: {
      title: "Apostille und Übersetzung Anfrage | Kostenlose Angebotsanfrage",
      description: "Füllen Sie das Formular aus und senden Sie uns eine unverbindliche Anfrage für Apostille, Superlegalisation oder amtliche Übersetzung. Wir antworten innerhalb weniger Stunden."
    },
    uk: {
      title: "Запит на апостиль та переклад | Безкоштовна цінова пропозиція",
      description: "Заповніть форму та надішліть нам незобов'язуючий запит на апостиль, суперлегалізацію або офіційний переклад. Відповімо протягом кількох годин."
    },
    ru: {
      title: "Запрос на апостиль и перевод | Бесплатное ценовое предложение",
      description: "Заполните форму и отправьте нам необязывающий запрос на апостиль, суперлегализацию или официальный перевод. Ответим в течение нескольких часов."
    },
    es: {
      title: "Consulta de apostilla y traducción | Presupuesto gratuito",
      description: "Complete el formulario y envíenos una consulta sin compromiso para apostilla, superlegalización o traducción oficial. Responderemos en pocas horas."
    }
  }
};

export function getSeoData(page: string, language: string): { title: string; description: string } {
  const pageData = seoTranslations[page];
  if (!pageData) {
    return { title: "Prelozim.sk", description: "" };
  }
  return pageData[language] || pageData.sk;
}
